import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Gift } from "lucide-react";

const STATUS = { unpaid: "text-amber-300", paid: "text-emerald-300", redeemed: "text-slate-400" };

export function AdminGifts() {
  const [gifts, setGifts] = useState(null);
  useEffect(() => { api.get("/admin/gifts").then((r) => setGifts(r.data)).catch(() => setGifts([])); }, []);
  if (gifts === null) return <div className="text-slate-500 text-sm">Loading gifts…</div>;
  const sold = gifts.filter((g) => g.status !== "unpaid");
  return (
    <div className="space-y-4" data-testid="admin-gifts">
      <div className="flex flex-wrap items-center gap-3">
        <div className="dg-eyebrow flex items-center gap-1"><Gift className="w-3 h-3" /> {sold.length} gift{sold.length === 1 ? "" : "s"} sold · ${sold.reduce((s, g) => s + Number(g.amount_usd || 0), 0).toFixed(2)}</div>
        <span className="text-xs text-slate-500">Unredeemed codes never expire. Customers buy at /gift; codes are entered on the booking page.</span>
      </div>
      {gifts.length === 0 && <div className="text-slate-500 text-sm">No gift sessions yet.</div>}
      <div className="grid gap-3 md:grid-cols-2">
        {gifts.map((g) => (
          <div key={g.gift_id} className="dg-card rounded-xl p-4 text-sm" data-testid={`gift-row-${g.gift_id}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="font-mono text-[#FFD600]">{g.code}</div>
                <div className="font-display font-semibold mt-1">{g.service_name} · ${Number(g.amount_usd).toFixed(2)}</div>
              </div>
              <span className={`dg-chip ${STATUS[g.status] || ""}`}>{g.status}</span>
            </div>
            <div className="text-slate-400 mt-2">From <span className="text-slate-200">{g.buyer_name}</span> ({g.buyer_email}) → <span className="text-slate-200">{g.recipient_name}</span>{g.recipient_email ? ` (${g.recipient_email})` : ""}</div>
            {g.message && <div className="text-slate-500 italic mt-1">"{g.message}"</div>}
            <div className="text-xs text-slate-500 mt-2">Bought {new Date(g.created_at).toLocaleDateString()}{g.paid_at ? ` · paid ${new Date(g.paid_at).toLocaleDateString()}` : ""}{g.booking_id ? ` · redeemed on booking ${g.booking_id}` : ""}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
